__turbopack_context__.v({
  "button": "button-module-scss-module__I9Jj7W__button",
  "default": "button-module-scss-module__I9Jj7W__default",
  "destructive": "button-module-scss-module__I9Jj7W__destructive",
  "ghost": "button-module-scss-module__I9Jj7W__ghost",
  "icon": "button-module-scss-module__I9Jj7W__icon",
  "lg": "button-module-scss-module__I9Jj7W__lg",
  "link": "button-module-scss-module__I9Jj7W__link",
  "outline": "button-module-scss-module__I9Jj7W__outline",
  "secondary": "button-module-scss-module__I9Jj7W__secondary",
  "sm": "button-module-scss-module__I9Jj7W__sm",
});
